import {fork} from 'redux-saga/effects'
import {getLatestNewsFlow, getNewsDetailFlow, getThemesFlow, getThemesDetailFlow} from './zhihuSaga'
import {loginFlow,logoutFlow} from './userSaga'
import {getTreeNodesFlow} from './devManagerSaga'

export default function* rootSaga() {
    yield fork(getLatestNewsFlow);
    yield fork(getNewsDetailFlow);
    yield fork(getThemesFlow);
    yield fork(getThemesDetailFlow);
    yield fork(loginFlow);
    yield fork(logoutFlow);
    yield fork(getTreeNodesFlow);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js